/**
 * A rota `/aguardando-entrega` (história 6.5) — a lista dos ganhos sem data registrada.
 *
 * **Ela publica o título pela rota**, e não só pelo item de navegação, pela mesma razão de
 * `/originados` e `/relatorios`: o item não existe para a SDR — a lista dela seria sempre vazia,
 * porque ela não é Responsável de Negócio nenhum —, e esconder item **não** é autorizar. Uma SDR
 * que digitasse o caminho chegaria aqui e o `<h1>` cairia no fallback `'CRM Orvalho do Sol'` sem
 * esta publicação. O texto é o **mesmo** do item (`TITULO_DO_AGUARDANDO_ENTREGA`), escrito uma vez
 * em `navegacao.ts`.
 *
 * O que ela recebe continua sendo decisão da RLS, e não desta rota: `200` com `[]`.
 */

import { createRoute } from '@tanstack/react-router'

import { AguardandoEntrega } from '@/modulos/negocios/AguardandoEntrega'
import { useDefinirTitulo } from '@/shell/Shell'
import { CAMINHOS, TITULO_DO_AGUARDANDO_ENTREGA } from '@/shell/navegacao'
import { rotaDaAplicacao } from './aplicacao'

function TelaDeAguardandoEntrega() {
  useDefinirTitulo(TITULO_DO_AGUARDANDO_ENTREGA)

  return <AguardandoEntrega />
}

export const rotaDeAguardandoEntrega = createRoute({
  getParentRoute: () => rotaDaAplicacao,
  path: CAMINHOS.aguardandoEntrega,
  component: TelaDeAguardandoEntrega,
})
